import { type JSX, MouseEvent, SyntheticEvent } from "react";
import Icon from "../../../atoms/Icon";
import {
  EllipsisDropdown,
  EllipsisDropdownLink,
} from "../../../general/EllipsisDropdown";

interface KarteDropdownProps {
  studentId: string;
  karteId: string;
  canPin?: boolean;
  isPinned: boolean;
  onPinClick: () => void;
  onDeleteClick: (e: MouseEvent<Element, MouseEvent> | SyntheticEvent) => void;
}

const KarteDropdown = ({
  studentId,
  karteId,
  canPin,
  isPinned,
  onPinClick,
  onDeleteClick,
}: KarteDropdownProps): JSX.Element => {
  return (
    <EllipsisDropdown position={{ top: "0", right: "3rem" }}>
      {canPin ? (
        <EllipsisDropdownLink onClick={onPinClick}>
          <Icon name="icon-pin" />
          {isPinned ? "トップに固定を解除" : "トップに固定"}
        </EllipsisDropdownLink>
      ) : null}
      <EllipsisDropdownLink href={`/students/${studentId}/kartes/${karteId}`}>
        <Icon name="icon-home" />
        詳細
      </EllipsisDropdownLink>
      <EllipsisDropdownLink onClick={onDeleteClick}>
        <Icon name="icon-trash" />
        削除
      </EllipsisDropdownLink>
    </EllipsisDropdown>
  );
};

export default KarteDropdown;
